import React from 'react';
//import PropTypes from 'prop-types';
//import styles from './SettingsContent.module.scss';
import SidebarBody from '../SidebarBody';

function SettingsBody(props) {
  props;
  return (
    <SidebarBody>
      <div>This is the Settings body content</div>
    </SidebarBody>
  );
}

SettingsBody.propTypes = {
};

export default SettingsBody;